import { render, staticRenderFns } from "./D2COMD0070.vue?vue&type=template&id=cbe94b58&scoped=true&"
import script from "./D2COMD0070.vue?vue&type=script&lang=js&"
export * from "./D2COMD0070.vue?vue&type=script&lang=js&"
import style0 from "./D2COMD0070.vue?vue&type=style&index=0&id=cbe94b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe94b58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VImg,VRow})
